module.exports = __webpack_public_path__ + "static/media/adar.d81358a9.jpg";